import config from "../config";

export function getBrowserLocale(options = {}) {
  const defaultOptions = { countryCodeOnly: false };
  const opt = { ...defaultOptions, ...options };
  const navigatorLocale = navigator.languages !== undefined
    ? navigator.languages[0]
    : navigator.language;
  if (!navigatorLocale) {
    return undefined;
  }
  const trimmedLocale = opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim();
  return trimmedLocale;
}

/**
 * Nous dit si le local en paramètre est supporté par l'application.
 * @param {String} locale Code ISO de la langue.
 * @returns {Boolean} true si locale est supporté par l'application.
 */
export function supportedLocalesInclude(locale) {
  return Object.keys(config.supportedLocales).includes(locale);
}

/**
 * Permet de ne pas retourner les clés de traduction vides.
 * Si une clé est vide, la langue par défaut sera affichée à la place.
 * @param {Object} trads Fichier JSON de traduction.
 * @returns {Object} Traductions sans les clés dont la valeur est "".
 */
export function removeEmptyTradKeys(trads) {
  return Object.entries(trads).reduce((acc, [key, value]) => {
    if (value && typeof value === "object") {
      const cleanedValue = removeEmptyTradKeys(value);
      if (Object.keys(cleanedValue).length) {
        acc[key] = cleanedValue;
      }
    } else if (value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});
}

/**
 * Convertit un nombre en string avec de l'espacement et limite au nombre de décimales donné en paramètres
 * (Ex: 1000.123 => 1 000,12).
 * @param {Number} value Nombre à convertir.
 * @param {Number} decimals Nombre de décimales à afficher, 2 par défaut
 * @returns {String} Nombre converti.
 */
export function moneyFilter(value, decimals = 2) {
  if (value == null) {
    return null;
  }
  return parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).split(String.fromCharCode(8239)).join("\xa0");
}

/**
 * Ajoute un espacement à chaque millier (ex: 1000 => 1 000).
 * @param {Number} value à convertir en String avec espacement.
 * @returns {String} Nombre converti.
 */
export function spaceNumber(value) {
  if (value == null) {
    return null;
  }
  return parseFloat(value).toLocaleString().split(String.fromCharCode(8239)).join("\xa0");
}

/**
 * Copie un texte dans le presse-papiers.
 * @param {String} toCopy Texte à copier.
 */
export function copyToClipboard(toCopy) {
  const el = document.createElement("textarea");
  el.value = toCopy;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);

  this.$toast.success({
    title: this.$t("toast.element-copie-presse-papier"),
  });
}

/**
 * Ouvre un lien externe dans un nouvel onglet.
 */
export function openInNewTab(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * Met le premier caractère d'une string en majuscule.
 * @param {String} string Mot ou phrase à transformer.
 * @returns {String} Mot ou phrase commençant par une majusule.
 */
export function ucFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Calcule le pourcentage de la valeur partielle par rapport au total.
 * @param {Number} partialValue valeur partielle.
 * @param {Number} totalValue valeur totale.
 * @returns {Number} Résultat du pourcentage.
 */
export function percentage(partialValue, totalValue) {
  return (100 * partialValue) / totalValue;
}

/**
 * Définit l'espacement supérieur de la sidebar.
 */
export function setAsideTop() {
  const mainHeader = document.querySelector("#main_header");
  const pageHeaderMain = document.querySelector("#page_header_main");
  const aside = document.querySelector("#aside_content");

  // Marge extérieure du site + hauteur de la topbar + hauteur de la zone du titre.
  aside.style.top = `${8 + mainHeader.offsetHeight + pageHeaderMain.offsetHeight}px`;
}
